import { render, staticRenderFns } from "./updateguest.vue?vue&type=template&id=2dfb3c88&"
import script from "./updateguest.vue?vue&type=script&lang=js&"
export * from "./updateguest.vue?vue&type=script&lang=js&"
import style0 from "./updateguest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports